import { v4 as uuidv4 } from "uuid";
import { getBuildMeta } from "../buildMeta";
import { getOrCreateClientId } from "./utils";

// Use the same session and diagnostic headers for Apollo and direct logout.
export function sessionRequestHeaders(token) {
  const { buildDate, commitHash } = getBuildMeta();
  return {
    authorization: token ? `Bearer ${token}` : "",
    client_id: getOrCreateClientId(),
    "x-request-id": uuidv4(),
    "x-build-date": buildDate,
    "x-commit-hash": commitHash,
    "X-Crosswind-Application": "mobile",
  };
}
